document.addEventListener("DOMContentLoaded", function () {
    var yall=function(){
        "use strict";
        return function(e){var n=(e=e||{}).lazyClass||"lazy",t=e.lazyBackgroundClass||"lazy-bg",o="idleLoadTimeout"in e?e.idleLoadTimeout:200,i=e.observeChanges||!1,r=e.events||{},a=e.noPolyfill||!1,s=window,c="requestIdleCallback",u="IntersectionObserver",l=u in s&&u+"Entry"in s,d=/baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),v=["srcset","src","poster"],f=[],queryDOM=function(e,o){return f.slice.call((o||document).querySelectorAll(e||"img."+n+",video."+n+",iframe."+n+",."+t))},yallLoad=function(n){var o=n.parentNode;"PICTURE"==o.nodeName&&yallApplyFn(queryDOM("source",o),yallFlipDataAttrs),"VIDEO"==n.nodeName&&yallApplyFn(queryDOM("source",n),yallFlipDataAttrs),yallFlipDataAttrs(n);var i=n.classList;i.contains(t)&&(i.remove(t),i.add(e.lazyBackgroundLoaded||"lazy-bg-loaded"))},yallBindEvents=function(e){for(var n in r)e.addEventListener(n,r[n].listener||r[n],r[n].options||void 0)},yallFlipDataAttrs=function(e){for(var t in v)if(v[t]in e.dataset){e.setAttribute(v[t],e.dataset[v[t]]);var o=e.parentNode;"SOURCE"===e.nodeName&&o.autoplay&&(o.load(),/Trident/.test(navigator.userAgent)&&o.play(),o.classList.remove(n)),e.classList.remove(n)}},yallApplyFn=function(e,n){for(var t=0;t<e.length;t++)s[u]&&n instanceof s[u]?n.observe(e[t]):n(e[t])},b=queryDOM();if(yallApplyFn(b,yallBindEvents),l&&!d){var g=new s[u]((function(e){yallApplyFn(e,(function(e){if(e.isIntersecting||e.intersectionRatio){var n=e.target;c in s&&o?s[c]((function(){yallLoad(n)}),{timeout:o}):yallLoad(n),g.unobserve(n),(b=b.filter((function(e){return e!=n}))).length||i||g.disconnect()}}))}),{rootMargin:("threshold"in e?e.threshold:200)+"px 0%"});yallApplyFn(b,g),i&&yallApplyFn(queryDOM(e.observeRootSelector||"body"),(function(n){new MutationObserver((function(){yallApplyFn(queryDOM(),(function(e){b.indexOf(e)<0&&(b.push(e),yallBindEvents(e),l&&!d?g.observe(e):(a||d)&&yallApplyFn(b,yallLoad))}))})).observe(n,e.mutationObserverOptions||{childList:!0,subtree:!0})}))}else(a||d)&&yallApplyFn(b,yallLoad)}
    }();
    yall();

    function isCalorieInRange(value, range) {
        const [min, max] = range.split("-").map(Number);
        console.log(min, max, value, value >= min, value <= max);
        return value >= min && value <= max;
    }

    function validData(value) {
        const regex = /^[A-Za-z]*$/;
        if (!regex.test(value)) {
            $("#dog_name").val(value.replace(/[^A-Za-z]/g, ""));
            var dogTitle = $("#dog_name").val();
            if (dogTitle == "") {
                $("#goToStep2_invalid").show();
                $("#goToStep2").hide();
            }
        }
    }

    var mealPackProductsHTML = $("#mealPackProductList").html();
    if (mealPackProductsHTML) var mealPackProducts = JSON.parse(mealPackProductsHTML);
    var productMealPackSelected = [];
    var mealPacketsNeededForFullPrice = 0;
    var checkOutNotes;
    const productIdToVariantMap = {
        15277960069491: "salmon",
        15045349114227: "pork",
        6539902091325: "chicken",
        6539890720829: "beef",
        6539896422461: "turkey",
        6539900125245: "lamb"
    };
    
    const packetsPerCalorieRange = {
        "41 - 78":{"full": 4, "topper" : 4, "fullinstruction" : "1/4 per day", "topperinstruction" : "1/8 per day", "mealpacksize" : "226", "supplementsize": "xs"},
        "79 - 96":{"full": 4, "topper" : 4, "fullinstruction" : "1/4 per day", "topperinstruction" : "1/8 per day", "mealpacksize" : "226", "supplementsize": "xs"},
        "97 - 116":{"full": 5, "topper" : 5, "fullinstruction" : "1/3 per day", "topperinstruction" : "1/6 per day", "mealpacksize" : "226", "supplementsize": "xs"},
        "117 - 129":{"full": 5, "topper" : 5, "fullinstruction" : "1/3 per day", "topperinstruction" : "1/6 per day", "mealpacksize" : "272", "supplementsize": "xs"},
        "130 - 156":{"full": 5, "topper" : 5, "fullinstruction" : "1/3 per day", "topperinstruction" : "1/6 per day", "mealpacksize" : "272", "supplementsize": "xs"},
        "157 - 169":{"full": 7, "topper" : 7, "fullinstruction" : "1/2 per day", "topperinstruction" : "1/4 per day", "mealpacksize" : "226", "supplementsize": "xs"},
        "170 - 185":{"full": 5, "topper" : 5, "fullinstruction" : "1/3 per day", "topperinstruction" : "1/6 per day", "mealpacksize" : "363", "supplementsize": "xs"},
        "186 - 196":{"full": 7, "topper" : 7, "fullinstruction" : "1/2 per day", "topperinstruction" : "1/4 per day", "mealpacksize" : "272", "supplementsize": "s"},
        "197 - 224":{"full": 5, "topper" : 5, "fullinstruction" : "1/3 per day", "topperinstruction" : "1/6 per day", "mealpacksize" : "429", "supplementsize": "s"},
        "225 - 277":{"full": 7, "topper" : 7, "fullinstruction" : "1/2 per day", "topperinstruction" : "1/4 per day", "mealpacksize" : "321", "supplementsize": "s"},
        "278 - 313":{"full": 7, "topper" : 7, "fullinstruction" : "1/2 per day", "topperinstruction" : "1/4 per day", "mealpacksize" : "429", "supplementsize": "s"},
        "314 - 369":{"full": 7, "topper" : 7, "fullinstruction" : "1/2 per day", "topperinstruction" : "1/4 per day", "mealpacksize" : "454", "supplementsize": "s"},
        "370 - 389":{"full": 14, "topper" : 14, "fullinstruction" : "1 per day", "topperinstruction" : "1/2 per day", "mealpacksize" : "272", "supplementsize": "s"},
        "390 - 464":{"full": 14, "topper" : 14, "fullinstruction" : "1 per day", "topperinstruction" : "1/2 per day", "mealpacksize" : "272", "supplementsize": "s"},
        "465 - 544":{"full": 14, "topper" : 14, "fullinstruction" : "1 per day", "topperinstruction" : "1/2 per day", "mealpacksize" : "321", "supplementsize": "m"},
        "545 - 624":{"full": 14, "topper" : 14, "fullinstruction" : "1 per day", "topperinstruction" : "1/2 per day", "mealpacksize" : "363", "supplementsize": "m"},
        "625 - 719":{"full": 14, "topper" : 14, "fullinstruction" : "1 per day", "topperinstruction" : "1/2 per day", "mealpacksize" : "454", "supplementsize": "m"},
        "720 - 779":{"full": 28, "topper" : 28, "fullinstruction" : "2 per day", "topperinstruction" : "1 per day", "mealpacksize" : "272", "supplementsize": "m"},
        "780 - 899":{"full": 28, "topper" : 28, "fullinstruction" : "2 per day", "topperinstruction" : "1 per day", "mealpacksize" : "272", "supplementsize": "m"},
        "900 - 1099":{"full": 28, "topper" : 28, "fullinstruction" : "2 per day", "topperinstruction" : "1 per day", "mealpacksize" : "321", "supplementsize": "m"},
        "1100 - 1249":{"full": 42, "topper" : 42, "fullinstruction" : "3 per day", "topperinstruction" : "1.5 per day", "mealpacksize" : "272", "supplementsize": "l"},
        "1250 - 1477":{"full": 28, "topper" : 28, "fullinstruction" : "2 per day", "topperinstruction" : "1 per day", "mealpacksize" : "454", "supplementsize": "l"},
        "1478 - 1564":{"full": 42, "topper" : 42, "fullinstruction" : "3 per day", "topperinstruction" : "1.5 per day", "mealpacksize" : "363", "supplementsize": "l"},
        "1565 - 1651":{"full": 42, "topper" : 42, "fullinstruction" : "3 per day", "topperinstruction" : "1.5 per day", "mealpacksize" : "363", "supplementsize": "l"},
        "1652 - 1889":{"full": 56, "topper" : 56, "fullinstruction" : "4 per day", "topperinstruction" : "2 per day", "mealpacksize" : "321", "supplementsize": "l"},
        "1890 - 2234":{"full": 42, "topper" : 42, "fullinstruction" : "3 per day", "topperinstruction" : "1.5 per day", "mealpacksize" : "454", "supplementsize": "l"},
        "2235 - 2353":{"full": 56, "topper" : 56, "fullinstruction" : "4 per day", "topperinstruction" : "2 per day", "mealpacksize" : "363", "supplementsize": "xl"},
        "2354 - 2523":{"full": 56, "topper" : 56, "fullinstruction" : "4 per day", "topperinstruction" : "2 per day", "mealpacksize" : "429", "supplementsize": "xl"},
        "2524 - 2847":{"full": 56, "topper" : 56, "fullinstruction" : "4 per day", "topperinstruction" : "2 per day", "mealpacksize" : "429", "supplementsize": "xl"},
    };

    const SKIO_BOX_IDS_BY_CALORIE_RANGE = {
      "41 - 78": "74f68f41-6f59-4fd8-a1fe-d87e47c80e62",
      "79 - 96": "f7e2fd8d-8c4b-4bc5-9bd5-4b137eb83d4c",
      "97 - 116": "bbb9a031-ccdc-4b68-a5c6-571e0f60455f",
      "117 - 129": "9748a723-80f6-4474-9599-2970a31b1c2e",
      "130 - 156": "d22e71de-78fe-43f6-9c03-a6cede73b914",
      "157 - 169": "19a87cc5-ad55-463a-9fb2-599f35d32653",
      "170 - 185": "84c2eaa2-0a54-404f-a6ff-82954171e162",
      "186 - 196": "f1a9dacd-83b6-4f26-bea0-d9f67e5bced9",
      "197 - 224": "5ebdb601-a844-41af-90a4-27447e99a238",
      "225 - 277": "9e298c54-0a26-4f9e-a73d-a4107a75ec2d",
      "278 - 313": "215bac33-8629-4ec4-9832-891280162399",
      "314 - 369": "9076fa83-b000-4429-a4f9-82d75f695967",
      "370 - 389": "f5af2c12-0b92-47bb-b66c-0b0adc07a70c",
      "390 - 464": "fe07c008-1311-4415-aa5a-ef8b80158ddb",
      "465 - 544": "4579a335-fa18-438e-82af-72a3f6f9e74a",
      "545 - 624": "6d4828e9-9c7e-436e-bd20-44319f40ffb6",
      "625 - 719": "d70618e2-f884-4962-b6d5-4fd4f1f3b15a",
      "720 - 779": "f6427677-470c-48a9-9153-3400ec64035a",
      "780 - 899": "e5de0ee1-3016-491a-956b-1257f6f15b1e",
      "900 - 1099": "d8407f64-4eed-49e0-b3d3-458432686d87",
      "1100 - 1249": "600f54db-5bcb-4df8-b49e-e662b87c37b6",
      "1250 - 1477": "4b682bb0-2a89-441b-bc14-4b5b3a8c5e88",
      "1478 - 1564": "8601cd89-f67a-4dd3-bbcb-b0fcb79fda12",
      "1565 - 1651": "975245f2-f9f2-48b3-a335-d9e3f91eb18d",
      "1652 - 1889": "16a5bd6f-1709-4948-bb0b-3782e676c8ee",
      "1890 - 2234": "a60224ff-87ad-4fdc-ab11-87868c45a982",
      "2235 - 2353": "80f7c941-4eb3-4962-a73a-53e3bc8fc4e0",
      "2354 - 2523": "7c8413ad-3f56-4d6e-b686-9d0eb41dbe37",
      "2524 - 2847": "df177d8d-278e-4ccd-a3e0-bbe19dbbf749",
    };

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toGMTString();
        if (exdays == 0) {
            document.cookie = cname + "=" + cvalue + ";path=/";
        } else {
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var loadScriptByURL = (id, url, callback, clientid = null) => {
        const isScriptExist = document.getElementById(id);
        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.async = true;
            if (clientid != null) {
                script.dataset.clientId = "86e5addd-30bc-5cb7-a69e-2d8cae2eced2";
            }
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }
        if (isScriptExist && callback) callback();
    };

    var foundLottiePlayers = document.getElementsByTagName("lottie-player");

    if (foundLottiePlayers.length > 0) {
        console.log("Found " + foundLottiePlayers.length + " lottie players, loading js");
        setTimeout(function () {
            loadScriptByURL("lottiejs", "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js", false);
        }, 3000);
    }

    // Put your application javascript here
    try {
        $(document).foundation();
    } catch (e) {
        console.warn('Foundation initialization error:', e);
    }

    // Safe Foundation accordion transition with fallback
    function safeAccordionDown(targetId, currentStepId) {
        try {
            $("#deeplinked-accordion").foundation("down", $(targetId));
        } catch (e) {
            if (currentStepId) {
                $(currentStepId).removeClass("is-active").find(".accordion-content").slideUp();
            }
            var $target = $(targetId);
            $target.closest(".accordion-item").addClass("is-active");
            $target.slideDown();
        }
    }

    function safeFoundationOpen(selector) {
        try {
            $(selector).foundation("open");
        } catch (e) {
            $(selector).show();
        }
    }

    // Auto-advance helper for radio steps. Some users tap the label's padding
    // (outside the inner .btn_submit span) — the label still checks the radio
    // and fires `change`, but the inner span's click handler never fires, so
    // the step would not auto-advance. This helper triggers the inner span's
    // existing click handler (which has the full advance logic) from change.
    function autoAdvanceFromRadio(radioName, nextClass, nextStepHashId) {
        if ($(nextStepHashId).hasClass("is-active")) return;
        var $checked = $("input[type=radio][name=" + radioName + "]:checked");
        if (!$checked.length) return;
        // Step 5 structure: <span class="btn_submit goToStep6"><input><label>...</label></span>
        var $span = $checked.closest("." + nextClass).first();
        if (!$span.length) {
            // Steps 4/7/8 structure: <input> <label for=...><span class="btn_submit goToStepN">...</span></label>
            var radioId = $checked.attr("id");
            $span = $("label[for='" + radioId + "']").find("." + nextClass).not(".button").first();
        }
        if ($span.length) $span.trigger("click");
    }

    // ---- Affirmation interstitial -------------------------------------------
    // Shows a reassuring screen between certain questions (Age, Weight, Body
    // Type). Copy comes from the #quizAffirmationCopy JSON block, which is
    // populated from theme settings. Forward-only: the Continue button runs the
    // supplied callback that reveals the next step. Fails open — if anything is
    // missing it advances immediately so the user is never trapped.
    var quizAffirmationCopy = null;
    try {
        var affirmEl = document.getElementById("quizAffirmationCopy");
        if (affirmEl) quizAffirmationCopy = JSON.parse(affirmEl.textContent);
    } catch (e) {
        quizAffirmationCopy = null;
    }

    function fillAffirmationText(str) {
        var name = "";
        try { name = ($("#dog_name").val() || "").trim(); } catch (e) {}
        return String(str || "").replace(/\[name\]/g, name || "your dog");
    }

    // Buckets the selected #dog_age option into "puppy" | "adult" | "senior" so
    // the age affirmation can show stage-specific copy. The month-based options
    // (under a year) are puppies; SENIOR_AGE+ years are seniors; everything in
    // between is an adult. Bump SENIOR_AGE to retune where senior starts.
    function getAgeCategory() {
        try {
            var label = ($("#dog_age option:selected").text() || "").toLowerCase();
            if (label.indexOf("month") !== -1) return "puppy";
            var SENIOR_AGE = 9;
            var years = parseInt(label, 10);
            if (!isNaN(years) && years >= SENIOR_AGE) return "senior";
            return "adult";
        } catch (e) {
            return "adult";
        }
    }

    // key: "age" | "weight" | "bodytype"; answer: age/body-type bucket or null
    function showAffirmation(key, answer, onContinue) {
        var run = function () { if (typeof onContinue === "function") onContinue(); };
        var $overlay = $("#quizAffirmation");

        if (!quizAffirmationCopy || !$overlay.length) { run(); return; }

        var entry = quizAffirmationCopy[key];
        if (entry && (key === "bodytype" || key === "age")) entry = entry[answer];
        if (!entry || (!entry.title && !entry.body)) { run(); return; }

        $overlay.find(".quiz-affirmation-title").text(fillAffirmationText(entry.title));
        $overlay.find(".quiz-affirmation-body").text(fillAffirmationText(entry.body));
        if (quizAffirmationCopy.continueText) {
            $overlay.find(".quiz-affirmation-continue").text(quizAffirmationCopy.continueText);
        }

        $("html, body").animate({ scrollTop: 0 }, 200);

        // Keep the quiz header (logo + the "Join 125,000+" social proof) on
        // screen instead of covering everything: drop the panel's top edge to
        // just below the social-proof header. offset() is document-relative, so
        // it stays correct once we've scrolled to the top. Falls back to
        // full-height if the header isn't found.
        try {
            var $affAnchor = $(".ReviewContent:visible").first();
            if (!$affAnchor.length) $affAnchor = $("#QuizStepsContent:visible").first();
            var affTop = $affAnchor.length
                ? Math.max(0, Math.round($affAnchor.offset().top + $affAnchor.outerHeight()))
                : 0;
            $overlay.css("top", affTop + "px");
        } catch (e) {
            $overlay.css("top", "0px");
        }

        // Set display explicitly (not .show()) so the flex centering in CSS is kept.
        $overlay.css("display", "flex");

        try {
            if (window.ncQuizPushEvent) {
                window.ncQuizPushEvent("quiz_affirmation_view", {
                    affirmation_key: key,
                    affirmation_answer: answer || null
                });
            }
        } catch (e) {}

        $overlay.find(".quiz-affirmation-continue").off("click.affirm").on("click.affirm", function () {
            $overlay.css("display", "none");
            run();
            // Record the now-revealed step's view (Continue isn't a .quizBtn).
            try {
                if (window.ncQuizTrackStepView) setTimeout(window.ncQuizTrackStepView, 150);
            } catch (e) {}
        });
    }

    //setTimeout(function(){ loadScriptByURL('hotjarJS', "https://static.hotjar.com/c/hotjar-1700676.js?sv=6", false); }, 3500);
    setTimeout(function () {
        loadScriptByURL("scaAffiliate", jQuery("#sca_affiliateJS").data("src"), false);
    }, 4000);

    setTimeout(function () {
        loadScriptByURL("subscribersAPPJS", jQuery("#subscribersAPP").data("src"), false);
    }, 4500);

    $(".btn_submit.button, .quizBack, .btn_submit").click(function () {
        // Block body-wide clicks briefly so the same finger lift / accidental
        // tap doesn't land on an option in the freshly-revealed next step.
        // Original was 1000ms (felt sluggish and blocked typing on step 9);
        // 500ms is long enough for finger lift but short enough to feel snappy.
        $("body.body-Wr").css({ "pointer-events": "none" });
        setTimeout(function () {
            $("body.body-Wr").css({ "pointer-events": "auto" });
        }, 500);
    });

    $(".quizBack").click(function () {
        step = "#step" + $(this).data("previous");
        console.log("blick, going to " + step);
        safeAccordionDown(step);
    });

    //STEP 1
    //SET DOG NAME IN FIELDS
    $("#dog_name").on("change paste keyup", function () {
        $(this).attr("sahil-value", $(this).val());
        $("#formData").data("dog_name", $(this).val());
        $(".dogNameV").html($(this).val());
        validData($(this).val());
    });

    $("#goToStep2").click(function () {
        jQuery(".qpFTitle").hide();
        $("#hStep2").show();
        try { mixpanel.track("Step view", { Step: "2" }); } catch (e) {}
        try {
            $("#deeplinked-accordion").foundation("down", $("#step2"));
        } catch (e) {
            // Fallback if Foundation is not available
            $("#hStep1").removeClass("is-active").find(".accordion-content").slideUp();
            $("#hStep2").addClass("is-active").find(".accordion-content").slideDown();
        }
    });

    //STEP 2
    $("#dog_age").change(function () {
        if ($("#dog_age").val() != "") {
            let valueMine = $(this).val();
            let htmlDog = $("#dog_age option:selected").html();
            // if(valueMine == '2'){
            //   valueMine = '2 to 4 months';
            // }else if(valueMine == '1.5'){
            //   valueMine = '4 to 7 months';
            // }else if(valueMine == '1.2'){
            //   valueMine = '7 to 12 months';
            // }
            $(this).attr("sahil-value", htmlDog);
            $("#formData").data("dog_age", $(this).val());
            $("#goToStep3").removeClass("disabled");
        } else {
            $("#goToStep3").addClass("disabled");
        }
    });

    $("#goToStep3").click(function () {
        if ($(this).hasClass("disabled")) {
            //nothing to do
        } else {
            showAffirmation("age", getAgeCategory(), function () {
                $("#hStep3").show();
                try { mixpanel.track("Step view", { Step: "3" }); } catch (e) {}
                safeAccordionDown("#step3", "#hStep2");
            });
        }
    });

    //STEP 3
    $("#dog_breed").on("change paste keyup", function () {
        if ($(this).val() != "") {
            $(this).attr("sahil-value", $(this).val());
            $("#formData").data("dog_breed", $(this).val());
            $(".dogBreed").html($(this).val());
            $("#goToStep4").removeClass("disabled");
        } else {
            $("#goToStep4").addClass("disabled");
        }
    });

    $("#goToStep4").click(function () {
        if ($(this).hasClass("disabled")) {
            //noting to do
        } else {
            $("#hStep4").show();
            try { mixpanel.track("Step view", { Step: "4" }); } catch (e) {}
            safeAccordionDown("#step4", "#hStep3");
        }
    });

    //STEP 4
    $("input[type=radio][name=dog_gender]").change(function () {
        if ($(this).val() != "") {
            $(this).parents("li.accordion-item").attr("sahil-value", $(this).val());
            $("#formData").data("dog_gender", $(this).val());
            $(".goToStep5").removeClass("disabled");
            if ($(this).val() == "boy") {
                $(".dogCastratV").html("neutered");
                $(".dogHisHer").html("his");
                $(".dogHeShe").html("he");
                $(".dogBoyGirl").html("boy");
            } else {
                $(".dogCastratV").html("spayed");
                $(".dogHisHer").html("her");
                $(".dogHeShe").html("she");
                $(".dogBoyGirl").html("girl");
            }
            setTimeout(function () { autoAdvanceFromRadio("dog_gender", "goToStep5", "#hStep5"); }, 200);
        } else {
            $(".goToStep5").addClass("disabled");
        }
    });

    $(".goToStep5").click(function () {
        var self = $(this);

        // For spans wrapping labels, find and check the associated radio button
        var $radio = null;
        var $label = self.find('label[for^="dog_gender"]');
        if ($label.length > 0) {
            $radio = $("#" + $label.attr("for"));
        } else {
            var $parentLabel = self.closest('label[for^="dog_gender"]');
            if ($parentLabel.length > 0) {
                $radio = $("#" + $parentLabel.attr("for"));
            }
        }

        if ($radio && $radio.length > 0 && !$radio.is(":checked")) {
            $radio.prop("checked", true).trigger("change");
        }

        setTimeout(function () {
            if (self.hasClass("disabled") && self.hasClass("button")) {
                //nothing to do - this is the disabled footer button
            } else {
                $("#hStep5").show();
                try { mixpanel.track("Step view", { Step: "5" }); } catch (e) {}
                safeAccordionDown("#step5", "#hStep4");
            }
        }, 10);
    });

    $("input[type=radio][name=dog_castrat]").change(function () {
        if ($(this).val() != "") {
            $(this).parents("li.accordion-item").attr("sahil-value", $(this).val());
            $("#formData").data("dog_castrat", $(this).val());
            $(".goToStep6").removeClass("disabled");
            setTimeout(function () { autoAdvanceFromRadio("dog_castrat", "goToStep6", "#hStep6"); }, 200);
        } else {
            $(".goToStep6").addClass("disabled");
        }
    });

    $(".goToStep6").click(function () {
        var self = $(this);

        // For spans wrapping labels/inputs, find and check the associated radio button
        var $radio = self.find("input[type=radio][name=dog_castrat]");
        if ($radio.length === 0) {
            var $label = self.find('label[for^="dog_castrat"]');
            if ($label.length > 0) {
                $radio = $("#" + $label.attr("for"));
            }
        }

        if ($radio && $radio.length > 0 && !$radio.is(":checked")) {
            $radio.prop("checked", true).trigger("change");
        }

        setTimeout(function () {
            if (self.hasClass("disabled") && self.hasClass("button")) {
                //nothing to do - this is the disabled footer button
            } else {
                // Ensure the data is set from the checked radio
                var checkedRadio = $("input[type=radio][name=dog_castrat]:checked");
                if (checkedRadio.length > 0) {
                    $("#formData").data("dog_castrat", checkedRadio.val());
                }
                $("#hStep6").show();
                try { mixpanel.track("Step view", { Step: "6" }); } catch (e) {}
                safeAccordionDown("#step6", "#hStep5");
            }
        }, 10);
    });

    //STEP 6
    $("#dog_weight").on("change paste keyup", function () {
        if ($(this).val() != "" && parseInt($(this).val()) >= 4) {
            $(this).attr("sahil-value", $(this).val());
            $("#formData").data("dog_weight", $(this).val());
            $("#goToStep7").removeClass("disabled");
        } else {
            $("#goToStep7").addClass("disabled");
        }

        var maxWeight = $("#dog_weight_range").attr("max");
        console.log(parseInt(maxWeight));
        if ($(this).val() > parseInt(maxWeight)) {
            $(this).val(parseInt(maxWeight));
            $(this).attr("sahil-value", $(this).val());
        }
    });

    $("#goToStep7").click(function () {
        if ($(this).hasClass("disabled")) {
            //nothing to do
        } else {
            showAffirmation("weight", null, function () {
                $("#hStep7").show();
                try { mixpanel.track("Step view", { Step: "7" }); } catch (e) {}
                safeAccordionDown("#step7", "#hStep6");
            });
        }
    });

    //step 7
    $("input[type=radio][name=dog_activity]").change(function () {
        if ($(this).val() != "") {
            $(this).parents("li.accordion-item").attr("sahil-value", $(this).val());
            $("#formData").data("dog_activity", $(this).val());
            $(".goToStep8").removeClass("disabled");
            setTimeout(function () { autoAdvanceFromRadio("dog_activity", "goToStep8", "#hStep8"); }, 200);
        } else {
            $(".goToStep8").addClass("disabled");
        }
    });

    $(".goToStep8").click(function () {
        var self = $(this);

        // For spans wrapping labels, find and check the associated radio button
        var $radio = null;
        var $label = self.find('label[for^="dog_activity"]');
        if ($label.length > 0) {
            $radio = $("#" + $label.attr("for"));
        } else {
            var $parentLabel = self.closest('label[for^="dog_activity"]');
            if ($parentLabel.length > 0) {
                $radio = $("#" + $parentLabel.attr("for"));
            }
        }

        if ($radio && $radio.length > 0 && !$radio.is(":checked")) {
            $radio.prop("checked", true).trigger("change");
        }

        setTimeout(function () {
            if (self.hasClass("disabled") && self.hasClass("button")) {
                //nothing to do - this is the disabled footer button
            } else {
                // Ensure the data is set from the checked radio
                var checkedRadio = $("input[type=radio][name=dog_activity]:checked");
                if (checkedRadio.length > 0) {
                    $("#formData").data("dog_activity", checkedRadio.val());
                }
                $("#hStep8").show();
                try { mixpanel.track("Step view", { Step: "8" }); } catch (e) {}
                safeAccordionDown("#step8", "#hStep7");
            }
        }, 10);
    });

    //step 8
    $("input[type=radio][name=dog_ideal_weight]").change(function () {
        if ($(this).val() != "") {
            $(this).parents("li.accordion-item").attr("sahil-value", $(this).val());
            $("#formData").data("dog_ideal_weight", $(this).val());
            $(".goToStep9").removeClass("disabled");
            setTimeout(function () { autoAdvanceFromRadio("dog_ideal_weight", "goToStep9", "#hStep9"); }, 200);
        } else {
            $(".goToStep9").addClass("disabled");
        }
    });

    var str1;
    $(".goToStep9").click(function () {
        var self = $(this);

        // For spans wrapping labels, find and check the associated radio button
        var $radio = null;
        var $label = self.find('label[for^="dog_ideal_weight"]');
        if ($label.length > 0) {
            // Span contains the label
            $radio = $("#" + $label.attr("for"));
        } else {
            // Check if the span is inside a label
            var $parentLabel = self.closest('label[for^="dog_ideal_weight"]');
            if ($parentLabel.length > 0) {
                $radio = $("#" + $parentLabel.attr("for"));
            }
        }

        // If we found a radio button, check it and set the data
        if ($radio && $radio.length > 0 && !$radio.is(":checked")) {
            $radio.prop("checked", true).trigger("change");
        }

        setTimeout(function () {
            // Check if this is the disabled footer button
            if (self.hasClass("disabled") && self.hasClass("button")) {
                //nothing to do - this is the disabled footer button
            } else {
                // Ensure the data is set from the checked radio
                var checkedRadio = $("input[type=radio][name=dog_ideal_weight]:checked");
                if (checkedRadio.length > 0) {
                    $("#formData").data("dog_ideal_weight", checkedRadio.val());
                }

                str1 = "\r\n age: " + $("#dog_age option:selected").val();
                str1 += " \r\n breed: " + $("#dog_breed").val();
                str1 += " \r\n gender: " + jQuery("#email_signup input[type=radio][name=dog_gender]:checked").val();
                str1 += " \r\n neutered: " + jQuery("#email_signup input[type=radio][name=dog_castrat]:checked").data("val");
                str1 += " \r\n weight: " + jQuery("#dog_weight").val();
                str1 += " \r\n activity:" + jQuery("#email_signup input[type=radio][name=dog_activity]:checked").data("val");
                str1 += " \r\n Weight: " + jQuery("#email_signup input[type=radio][name=dog_ideal_weight]:checked").data("val");
                calories = calculate_quiz_calories();
                jQuery("#formNote").empty();
                jQuery("#formNote").html(str1);
                var bodyType = checkedRadio.length > 0 ? checkedRadio.data("val") : null;
                showAffirmation("bodytype", bodyType, function () {
                    $("#hStep9").show();
                    try { mixpanel.track("Step view", { Step: "9" }); } catch (e) {}
                    safeAccordionDown("#step9", "#hStep8");
                    $("#step9").addClass("active");
                    calories = calculate_quiz_calories();
                    $("#caloriesResCal").html(calories.toFixed(0));
                });
            }
        }, 10);
    });

    //step 9
    const IsEmail = (email) => {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        } else {
            return true;
        }
    };

    $("#k_id_email").on("change paste keyup", function () {
        if ($(this).val() != "" && IsEmail($(this).val()) == true) {
            $("#formData").data("k_id_email", $(this).val());
            $("#goToStep10").removeClass("disabled");
        } else {
            $("#goToStep10").addClass("disabled");
        }
    });

    const get_calories_var = (calories) => {
        if (calories > 0 && calories <= 373) {
            return 0;
        } else if (calories > 373 && calories <= 550) {
            return 1;
        } else if (calories > 550 && calories <= 800) {
            return 2;
        } else if (calories > 800 && calories <= 1000) {
            return 3;
        } else {
            return 4;
        }
    };

    const calculate_quiz_calories = () => {
        // Q:Activity : inactive 1 somewhat active 1.3 very active 1.6
        activity = $("#formData").data("dog_activity");
        $("#formData").append("Activity: " + activity);
        console.log(`Activity: ${activity}`);

        // Q:Signlament :  Intact 1.8  Nertured 1.6
        signlament = $("#formData").data("dog_castrat");
        $("#formData").append("signlament: " + signlament + "<br/>");
        console.log(`signlament: ${signlament}`);

        // RER = 70  x (bw in kg)^.75
        // Q:convert lb to kg = lb /2.2
        age_rer = $("#formData").data("dog_age");
        $("#formData").append("age_rer: " + age_rer + "<br/>");
        console.log(`age_rer: ${age_rer}`);

        bw = $("#formData").data("dog_weight") / 2.2;
        $("#formData").append("bw is :" + bw + "<br/>");

        console.log(`bw: ${bw}`);

        //3 *70 * ( (bw / 2.2) ^ 0.75)
        rer = age_rer * 70 * Math.pow(bw, 0.75);
        $("#formData").append("rer = age_rer * 70 * Math.pow(bw, 0.75)");
        $("#formData").append("RER is :" + rer + "<br/>");
        console.log(`bw: ${bw}`);

        //Q:Body Condition (BCS): 1.2 underwight 1 ideal  0.8 over weight
        body_condition = $("#formData").data("dog_ideal_weight");
        $("#formData").append("body_condition is :" + body_condition + "<br/>");
        console.log(`body_condition: ${body_condition}`);

        //Calorie Calculation = rer x signlament x activity x body_condition
        calories = rer * activity * signlament * body_condition;
        calories = parseInt(calories);
        console.log(`calories: ${calories}`);
        if (isNaN(calories)) {
            calories = 1000;
        }
        return calories;
    };

    const process_step_10 = () => {
        $("#hStep10").show();
        try { mixpanel.track("Step view", { Step: "10" }); } catch (e) {}
        safeAccordionDown("#step10", "#hStep9");
        jQuery("#calories_total").val(calories);
        var raw_food = JSON.parse($("#rawJSON").html());
        var slightly_cooked = JSON.parse($("#cookedJSON").html());
        all_foods = raw_food.product;
        all_foods = all_foods.concat(slightly_cooked.product);
        var_pos = get_calories_var(calories);
        for (let i = 0; i < all_foods.length; i++) {
            if (all_foods[i].id == 6539902091325 || all_foods[i].id == 6539910774845) {
                discount = jQuery("#quizPTop").data("discount");
                total = (calories * all_foods[i].variants[var_pos].price) / 1000;
                if (discount > 0) {
                    discounted_price = total - (total * discount) / 100;
                    discounted_price = discounted_price.toFixed(2);
                    jQuery("#fc" + all_foods[i].id).html(
                        "<span class='discountedPrice'><span class='discountedPriceVal'>" +
                            discounted_price +
                            "</span> <span class='oldPriceVal'>$" +
                            total.toFixed(2) +
                            "</span></span>"
                    );
                } else {
                    jQuery("#fc" + all_foods[i].id).html("<span class='regularPrice'>" + total.toFixed(2) + "</span>");
                }
            }
        }
        firstdiscount = getCookie("firstdiscount");
        if (firstdiscount != "") {
            //nothing to do
        } else {
            discount_code = $("#discountCode").data("code");
            _apply_discount(discount_code);
        }
    };

    const initializeKlaviyoQuiz = () => {
        KlaviyoSubscribe.attachToForms("#email_signup", {
            hide_form_on_success: false,
            custom_success_message: true,
            extra_properties: {
                $quizDogName: () => jQuery("#dog_name").val(),
                $quizDogAgeMultiplier: () => jQuery("#dog_age").val(),
                $quizDogAge: () => jQuery("#dog_age option:selected").text(),
                $quizDogBreed: () => jQuery("#dog_breed").val(),
                $quizDogGender: () => jQuery("#email_signup input[type=radio][name=dog_gender]:checked").val(),
                $quizDogSpayNeuter: () => jQuery("#email_signup input[type=radio][name=dog_castrat]:checked").data("val"),
                $quizDogWeight: () => jQuery("#dog_weight").val(),
                $quizDogActivityVal: () => jQuery("#dog_activity").val(),
                $quizDogActivity: () => jQuery("#email_signup input[type=radio][name=dog_activity]:checked").data("val"),
                $quizDogIdealWeight: () => jQuery("#email_signup input[type=radio][name=dog_ideal_weight]:checked").data("val"),
                Brand: "Klaviyo",
            },
            success: function ($form) {
                jQuery(".klaviyo_messages").addClass("active");
                jQuery(".wyeWrap, .klaviyo_form_actions").hide();
                jQuery("#goToStep10").removeClass("disabled");
                prepare_step_11();
            },
        });
    };

    var loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);
        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }
        if (isScriptExist && callback) callback();
    };

    loadScriptByURL("klaviyo_subscribe", "https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js", initializeKlaviyoQuiz);

    $("#goToStep10").click(function () {
        if ($(this).hasClass("disabled")) {
            //nothing to do
        } else {
            process_step_10();
        }
    });

    //step 10
    $("input[type=radio][name=dog_raw_cooked]").change(function () {
        if ($(this).val() != "") {
            $("#formData").data("dog_raw_cooked", $(this).val());
            $("#goToStep11").removeClass("disabled");
        } else {
            $("#goToStep11").addClass("disabled");
        }
    });

    const prepare_step_11 = () => {
        $("#faqQuizP").hide();
        $(".quizPTopMenu .button").each(function () {
            $(this).removeClass("lblue");
            $(this).addClass("white");
            $(".btn3").addClass("lblue");
        });
        if ($("#formData").data("dog_raw_cooked") == "raw") {
            recipes_nr = 5;
        } else {
            recipes_nr = 4;
        }
        jQuery("#nrRecipesMP").html(recipes_nr);
        var raw_food = JSON.parse($("#rawJSON").html());
        var slightly_cooked = JSON.parse($("#cookedJSON").html());
        $("#hStep11").show();
        try { mixpanel.track("Step view", { Step: "11" }); } catch (e) {}
        safeAccordionDown("#step11", "#hStep10");
        calories = calculate_quiz_calories();
        $("#formData").append("calories = rer * activity * signlament * body_condition;" + "<br/>");
        $("#formData").append("calories =" + calories + "<br/>");
        food = slightly_cooked;
        wrapper_class = "hQuizCookedRecipes";
        str = "";
        var_pos = get_calories_var(calories);
        for (let i = 0; i < food.product.length; i++) {
            total = (calories * food.product[i].variants[var_pos].price) / 1000; //10 because price is for 10 cal and 100 because it's cents and we want to display dollars
            discount = jQuery("#quizPTop").data("discount");
            if (discount > 0) {
                discounted_price = total - (total * discount) / 100;
                discounted_price = discounted_price.toFixed(2);
                total_txt =
                    "<span class='discountedPrice'><span class='discountedPriceVal'>" +
                    discounted_price +
                    "</span> <span class='oldPriceVal'>$" +
                    total.toFixed(2) +
                    "</span></span>";
            } else {
                total_txt = "<span class='regularPrice'>" + total.toFixed(2) + "</span>";
            }
            jQuery("." + wrapper_class + " #pid" + food.product[i].id + " .ppDay").html(total_txt);
            jQuery("." + wrapper_class + " #pid" + food.product[i].id).data("vid", food.product[i].variants[var_pos].id);
            jQuery("." + wrapper_class + " #pid" + food.product[i].id).data("sid", food.product[i].seeling_plan);
        }
        qfoodtype = $("input[type=radio][name=dog_raw_cooked]:checked").val();
        if (qfoodtype == "raw") {
            $(".hQuizRawRecipes").css("display", "flex");
        } else {
            $(".hQuizCookedRecipes").css("display", "flex");
        }
    };

    $("#goToStep11").click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("disabled")) {
            //nothing to do
        } else {
            prepare_step_11();
        }
    });

    var _apply_discount = (discount_code) => {
        $.get("/discount/" + discount_code, function (data, textStatus, jqXHR) {
            var success = $($.parseHTML(data)).find(".order-summary-toggle__total-recap");
            if (typeof success[0].outerHTML != "undefined") {
                setCookie("firstdiscount", "yes", 365);
            }
        });
    };

    const get_active_variant = (product, calories) => {
        return product.variants[calories];
    };

    const getMealPacketsNeededForCalorie = (calorie) => {
        for (const key in packetsPerCalorieRange) {
            if (packetsPerCalorieRange.hasOwnProperty(key)) {
                const [start, end] = key.split(" - ");
                if (calorie >= parseInt(start) && calorie <= parseInt(end)) {
                    return packetsPerCalorieRange[key];
                }
            }
        }
        return "No matching range found";
    };

    // Helper function to get the correct supplement selling plan based on dog size
    // Supplement selling plans based on plan type and dog size
    // seeling_plan = 2nd plan (4 weeks)
    // seeling_plan2 = 3rd plan (8 weeks)
    // seeling_plan4 = 4th plan (16 weeks)
    // seeling_plan4 = 1st plan (2 weeks)
    const getSupplementSellingPlan = (treatProduct, supplementSize, planType) => {
        const size = supplementSize.toLowerCase();
        // console.log(treatProduct)
        // console.log(supplementSize)
        // console.log(planType)

        // Plan type: 14 = Full Plan (every 2 weeks), 28 = Topper Plan (every 4 weeks)
        if (planType == 14) {
            // Full Plan
            if (size === "xs") {
                // XS: 8 weeks for Full Plan
                if (treatProduct.seeling_plan4 && treatProduct.seeling_plan4 !== "") {
                    return treatProduct.seeling_plan4;
                }
            } else if (size === "s") {
                // M
                if (treatProduct.seeling_plan3 && treatProduct.seeling_plan3 !== "") {
                    return treatProduct.seeling_plan3;
                }
            } else if (size === "m") {
                // M
                if (treatProduct.seeling_plan2 && treatProduct.seeling_plan2 !== "") {
                    return treatProduct.seeling_plan2;
                }
            } else {
                // L, XL
                return treatProduct.seeling_plan;
            }
        } else {
            // Topper Plan
            if (size === "xs") {
                // XS: 16 weeks for Topper Plan
                if (treatProduct.seeling_plan4 && treatProduct.seeling_plan4 !== "") {
                    return treatProduct.seeling_plan4;
                }
            } else if (size === "s") {
                // S: 8 weeks for Topper Plan
                if (treatProduct.seeling_plan3 && treatProduct.seeling_plan3 !== "") {
                    return treatProduct.seeling_plan3;
                }
            } else {
                // M, L, XL: 4 weeks for Topper Plan
                if (treatProduct.seeling_plan2 && treatProduct.seeling_plan2 !== "") {
                    return treatProduct.seeling_plan2;
                }
            }
        }

        // Fallback to first selling plan if nothing else matches
        return treatProduct.seeling_plan;
    };

    // Helper function to check if a product is a supplement based on handle or type
    const isSupplementProduct = (treatProduct) => {
        // Check if product has a handle that indicates it's a supplement
        const supplementHandles = ["tummy-tonic", "dental-daily"];

        if (treatProduct.handle) {
            const handle = treatProduct.handle.toLowerCase();
            for (const supplementHandle of supplementHandles) {
                if (handle.includes(supplementHandle)) {
                    return true;
                }
            }
        }

        // // Also check product type if available
        // if (treatProduct.product_type) {
        //   const type = treatProduct.product_type.toLowerCase();
        //   if (type.includes('supplement')) {
        //     return true;
        //   }
        // }

        // // Check if is_supplement flag is set
        // if (treatProduct.is_supplement === true) {
        //   return true;
        // }

        return false;
    };

      // Helper function to get the correct box ID based on calories
    function getSkioBoxIdForCalories(calories) {
      for (const range in SKIO_BOX_IDS_BY_CALORIE_RANGE) {
        if (isCalorieInRange(calories, range)) {
            return SKIO_BOX_IDS_BY_CALORIE_RANGE[range];
        }
      }
      // Fallback to highest range if no match found
      return SKIO_BOX_IDS_BY_CALORIE_RANGE["2524 - 2847"];
    }

    const distributeProducts = (products, quantity) => {
        const variantToProductIndex = {};
        const variants = Object.values(productIdToVariantMap);
        products.forEach((product, index) => {
            const variant = product.relateToMain;
            variantToProductIndex[variant] = index;
        });
        for (let i = 0; i < variants.length && quantity > 0; i++) {
            const variant = variants[i];
            const productIndex = variantToProductIndex[variant];
            if (productIndex !== undefined) {
                products[productIndex].mealPacketsNeededForFullPack += 1;
                quantity -= 1;
                mealPacketsNeededForFullPrice += products[productIndex].price / 100; // Update the price
            }
        }
        while (quantity > 0) {
            for (let i = 0; i < products.length && quantity > 0; i++) {
                products[i].mealPacketsNeededForFullPack += 1;
                quantity -= 1;
                mealPacketsNeededForFullPrice += products[i].price / 100; // Update the price
            }
        }
        return products;
    };

    const prepare_step_12 = () => {
        $("#faqQuizP").hide();
        $("#hStep12").show();
        safeAccordionDown("#step12", "#hStep11");
        var slightly_cooked = JSON.parse($("#cookedJSON").html());
        calories = calculate_quiz_calories();
        // calories = 1890;
        console.log("calories:" + calories);
        food = mealPackProducts;
        var_pos = get_calories_var(calories);
        var parray = get_active_meals_pid();
        var total = 0;
        quantity = Math.round((calories / parray.length / 10) * 14);
        var parray2 = [];
        var foundExtra = false;
        mealPacketsNeeded = getMealPacketsNeededForCalorie(calories); // Given calories
        var extraPackagesNeeded = mealPacketsNeeded.full % parray.length;
        var checkCalorie = false;
        console.log(parray);
        parray.forEach(function (eachActiveProductId) {
            let itemVariant = productIdToVariantMap[eachActiveProductId];
            for (let i = 0; i < food.products[itemVariant].length; i++) {
                if (
                    food.products[itemVariant][i]?.quiz_version_v2 &&
                    isCalorieInRange(calories, food.products[itemVariant][i].option1)
                ) {
                    console.log("Found");
                    food.products[itemVariant][i].mealPacketsNeeded = mealPacketsNeeded;
                    food.products[itemVariant][i].mealPacketsNeededForFullPack = Math.floor(mealPacketsNeeded.full / parray.length);
                    food.products[itemVariant][i].mealPacketsNeededForTopUpPack = Math.floor(mealPacketsNeeded.topper / parray.length);
                    food.products[itemVariant][i].mealPacketsNeededForFullPackExtra = 0;
                    food.products[itemVariant][i].mealPacketsNeededForTopUpPackExtra = 0;
                    food.products[itemVariant][i].relateToMain = itemVariant;
                    productMealPackSelected.push(food.products[itemVariant][i]);
                    var price = food.products[itemVariant][i].price / 100;
                    mealPacketsNeededForFullPrice += price * food.products[itemVariant][i].mealPacketsNeededForFullPack;
                    checkCalorie = true;
                }
            }
        });
        var discountPercentage = 100 - parseInt($("#hStep12").attr("discountCode"));
        discountPercentage = discountPercentage / 100;
        console.log("discountPercentage", discountPercentage);
        productMealPackSelected = distributeProducts(productMealPackSelected, extraPackagesNeeded);
        jQuery("#totalFullPlan").html(
            "<span style='text-decoration: line-through;'>" +
                (mealPacketsNeededForFullPrice / 14).toFixed(2) +
                "</span> $" +
                ((mealPacketsNeededForFullPrice * 0.6) / 14).toFixed(2)
        );
        jQuery("#totalTopperPlan").html(
            "<span style='text-decoration: line-through;'>" +
                (mealPacketsNeededForFullPrice / 28).toFixed(2) +
                "</span> $" +
                ((mealPacketsNeededForFullPrice * 0.6) / 28).toFixed(2)
        );
        if (checkCalorie == false) {
            alert(
                "Custom Plan Required We're sorry, but your dog's size or calorie needs exceed our standard meal plans. However, we'd still love to help! Please email us at info@nutricanine.ca for assistance in creating a custom plan tailored to your dog's specific requirements."
            );
            window.location.replace("https://nutricanine.ca/pages/meal-plan-questionnaire");
        }
    };

    $("#goToStep12").click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("disabled")) {
            //nothing to do
        } else {
            prepare_step_12();
        }
    });

    const get_active_meals_pid = () => {
        var parray = [];
        meals_selected = jQuery(".quizMeal.active");
        for (i = 0; i < meals_selected.length; i++) {
            var pid = meals_selected[i].id.replace("pid", "");
            parray.push(parseInt(pid));
        }
        return parray;
    };

    const get_active_treats = () => {
        var parray = [];
        meals_selected = jQuery(".hQuizTreat.active");
        if (meals_selected.length == 0) {
            return false;
        }
        for (i = 0; i < meals_selected.length; i++) {
            var pid = meals_selected[i].getAttribute("data-pid");
            var vid = meals_selected[i].getAttribute("data-vid");
            console.log("got treat pid:" + pid + " vid:" + vid);
            parray.push({
                pid: pid,
                vid: vid,
            });
        }
        return parray;
    };

    jQuery(".hQuizPlan").click(function (e) {
        jQuery(".hQuizPlan").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#goToQuizChk2").removeClass("disabled");
    });

    jQuery(".hQuizTreat").click(function (e) {
        jQuery(this).toggleClass("active");
        var button = jQuery(this).find(".treat_add_button");
        if (jQuery(this).hasClass("active")) {
            button.text("Added");
        } else {
            button.text("Add to meal plan");
        }
    });

    const show_prices_treats = () => {
        var treats_json = JSON.parse($("#treatsJSON").html());
        var calories = calculate_quiz_calories();
        var plan = jQuery(".hQuizPlan.active").data("plan");

        for (let i = 0; i < treats_json.product.length; i++) {
            // Skip handles that didn't resolve to a published product (empty
            // object with no variants) — avoids a crash that would also abort
            // the rest of the step-12 -> step-13 transition.
            if (
                !treats_json.product[i] ||
                !treats_json.product[i].id ||
                !treats_json.product[i].variants ||
                !treats_json.product[i].variants[0]
            ) {
                continue;
            }
            price = (treats_json.product[i].variants[0].compare_at_price / 100).toFixed(2);
            discounted_price = (treats_json.product[i].variants[0].price / 100).toFixed(2);
            jQuery("#treat" + treats_json.product[i].id).html(
                "<span class='regular_price'>$" + price + "</span> $" + discounted_price
            );

            // Update subscription frequency for supplements
            if (isSupplementProduct(treats_json.product[i])) {
                const supplementSize = getMealPacketsNeededForCalorie(calories).supplementsize;
                const size = supplementSize.toLowerCase();
                let frequency = "";

                // Plan 14 = Full Plan (every 2 weeks), Plan 28 = Topper Plan (every 4 weeks)
                if (plan == 14) {
                    // Full Plan
                    if (size === "xs") {
                        frequency = "1 tub (150g) every 16 wk";
                    } else if (size === "s") {
                        frequency = "1 tub (150g) every 8 wk";
                    } else if (size == "m") {
                        frequency = "1 tub (150g) every 4 wk";
                    } else {
                        frequency = "1 tub (150g) every 2 wk";
                    }
                } else {
                    // Topper Plan
                    if (size === "xs") {
                        frequency = "1 tub (150g) every 16 wk";
                    } else if (size === "s") {
                        frequency = "1 tub (150g) every 8 wk";
                    } else {
                        frequency = "1 tub (150g) every 4 wk";
                    }
                }

                jQuery("#treatDesc" + treats_json.product[i].id).html(frequency);
            }
        }
    };

    jQuery("#goToQuizChk2").click(function (e) {
        if (jQuery(this).hasClass("disabled")) return;
        if (jQuery(".hQuizPlan.active").length === 0) return;
        show_prices_treats();
        $("#hStep13").show();
        safeAccordionDown("#step13", "#hStep12");
        calories = calculate_quiz_calories();
        if (jQuery(".hQuizPlan.active").data("plan") == 14) {
            $(".every_x_times").html(2);
            jQuery("#formNote").prepend("\r\n Plan: full");
            str1 += " \r\n calories per day: " + calories;
        } else {
            jQuery("#formNote").prepend(" \r\n Plan: topper");
            str1 += " \r\n calories per day: " + Math.ceil(calories / 2);
        }
    });

    jQuery("#goToQuizChk3").click(function (e) {
        try { mixpanel.track("Quiz Checkout", { Phase: "Initiate Checkout" }); } catch (e) {}
        safeFoundationOpen("#loadingCheckout");
        $(".ProgressBar").addClass("progressing");
        var calories = calculate_quiz_calories();

        // Fast LLM-style typewriter animation for dog info
        var thoughts = [
            "Analyzing age... " + $("#dog_age option:selected").text(),
            "Checking breed... " + $("#dog_breed").val(),
            "Recording weight... " + $("#dog_weight").val() + " lbs",
            "Activity level... " + $("input[type=radio][name=dog_activity]:checked").data("val"),
            "Body condition... " + $("input[type=radio][name=dog_ideal_weight]:checked").data("val"),
            "Calculating daily calories... " + calories + " kcal",
            "Building personalized meal plan...",
        ];

        var $typingLine = $(".dogInfoSummary .typing-line");
        var currentIndex = 0;

        function typeText(text, callback) {
            var charIndex = 0;
            $typingLine.text("");
            function typeChar() {
                if (charIndex < text.length) {
                    $typingLine.text(text.substring(0, charIndex + 1));
                    charIndex++;
                    setTimeout(typeChar, 12);
                } else if (callback) {
                    setTimeout(callback, 200);
                }
            }
            typeChar();
        }

        function showNextThought() {
            if (currentIndex < thoughts.length) {
                typeText(thoughts[currentIndex], function () {
                    currentIndex++;
                    showNextThought();
                });
            }
        }

        showNextThought();

        var_pos = get_calories_var(calories);
        var slightly_cooked = JSON.parse($("#cookedJSON").html());
        var food = slightly_cooked;
        var parray = get_active_meals_pid();
        var quantity = Math.round((calories / parray.length / 10) * 14);
        var parray2 = [];
        var plan = jQuery(".hQuizPlan.active").data("plan");
        checkOutNotes = "\r\n \r\n";
        var feedingInstructionToPackingSlip;

        // First box, increment if adding multiple boxes of same ID
        var dynamicBoxIndex = 0; 
        // Get the correct Skio box ID based on calorie range
        var dynamicBoxId = getSkioBoxIdForCalories(calories);

        productMealPackSelected.forEach(function (selectedMealPack) {
            if (plan == "14") {
                subName = selectedMealPack.seeling_plan;
                quantity = selectedMealPack.mealPacketsNeededForFullPack;
                feedingInstructionToPackingSlip = "\r\n Feeding instructions: " + selectedMealPack.mealPacketsNeeded.fullinstruction;
            } else {
                subName = selectedMealPack.seeling_plan2;
                quantity = selectedMealPack.mealPacketsNeededForFullPack;
                feedingInstructionToPackingSlip = "\r\n Feeding instructions: " + selectedMealPack.mealPacketsNeeded.topperinstruction;
            }
            checkOutNotes += "\r\n";
            parray2.push({
                id: selectedMealPack.variantid,
                quantity: quantity,
                selling_plan: subName,
                properties: {
                    _dynamicBoxId: dynamicBoxId,
                    _dynamicBoxIndex: dynamicBoxIndex,
                    _Calories: calories,
                    _Days: plan,
                },
            });
        });
        console.log("2333232323");
        jQuery("#formNote").prepend(feedingInstructionToPackingSlip);
        jQuery("#formNote").prepend("\r\n Dog Name: " + jQuery("#dog_name").val());
        checkOutNotesOrg = jQuery("#formNote").html();
        checkOutNotes = checkOutNotesOrg + checkOutNotes;
        treats = get_active_treats();
        var supplementSizeData = getMealPacketsNeededForCalorie(calories);
        var supplementSize = supplementSizeData.supplementsize; // Default to 'm' if not found

        if (treats) {
            // If there are treats selected
            // Increment box index for treats so they ship together but as separate line items
            dynamicBoxIndex++;
            var treats_json = JSON.parse($("#treatsJSON").html()); // Retrieve the Treats JSON data created in the quiz template
            console.log(treats_json);
            for (let i = 0; i < treats_json.product.length; i++) {
                // For each product in the Treats JSON data
                for (let j = 0; j < treats.length; j++) {
                    treatPlan = "";
                    if (parseInt(treats[j].pid) == treats_json.product[i].id) {
                        // Check if this treat is a supplement product
                        if (isSupplementProduct(treats_json.product[i])) {
                            // Use supplement-specific selling plan based on dog size
                            console.log(
                                `Supplement detected: ${
                                    treats_json.product[i].handle || treats_json.product[i].id
                                }, Dog Size: ${supplementSize}`
                            );
                            treatPlan = getSupplementSellingPlan(treats_json.product[i], supplementSize, plan);
                        } else if (plan == "14") {
                            // Checks if they are on the full plan
                            console.log(`Treat Full Plan: ${treats_json.product[i]}`);
                            treatPlan = treats_json.product[i].seeling_plan;
                        } else {
                            // They are on the topper plan
                            console.log(`Treat Topper Plan: ${treats_json.product[i]}`);
                            if (treats_json.product[i].seeling_plan2 !== "" && treats_json.product[i].seeling_plan2 !== null) {
                                // If there is no selling plan 2, use selling plan 1
                                console.log(`Using Treat Selling Plan 2: ${treats_json.product[i].seeling_plan2}`);
                                treatPlan = treats_json.product[i].seeling_plan2;
                            } else {
                                console.log(`Using Treat Selling Plan 1: ${treats_json.product[i].seeling_plan2}`);
                                treatPlan = treats_json.product[i].seeling_plan;
                            }
                        }
                        parray2.push({
                            id: treats[j].vid,
                            quantity: 1,
                            selling_plan: treatPlan,
                            properties: {
                                // _dynamicBoxId: "f0cbdcce-c384-45b1-a891-8301c7f2567d",
                                // _dynamicBoxIndex: dynamicBoxIndex,
                                _Days: plan,
                            },
                        });
                    }
                }
            }
        }
        if (plan == "14") {
            parray2.push({
                id: 40749772570685,
                quantity: 1,
            });
        } else {
            parray2.push({
                id: 40749772472381,
                quantity: 1,
            });
        }
        firstdiscount = getCookie("firstdiscount");
        // ponytail: a referral code in localStorage always wins, even past the firstdiscount cookie
        var referralCode = "";
        try { referralCode = localStorage.getItem("referralDiscountCode") || ""; } catch (e) {}
        if (referralCode) {
            discount_code = referralCode;
        } else if (firstdiscount != "") {
            var discount_code = "";
        } else {
            discount_code = $("#discountCode").data("code");
        }
        cartNote = function () {
            var mineNote = "";

            // To get Notes for Dog Name
            var dogName = $("#dog_name").attr("sahil-value");
            if (dogName == "") {
                alert("Your Dog name is Empty so please refill the quiz again.");
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            }
            mineNote += "Dog name: " + dogName + "\r\n";
            calories = calculate_quiz_calories();
            // To get Notes for Feeding Instruction
            var plan = jQuery(".hQuizPlan.active").data("plan");
            var feedingInstruction = "";
            var planName = "";
            if (plan == "14") {
                feedingInstruction = productMealPackSelected[0].mealPacketsNeeded.fullinstruction;
                planName = "full";
                mineNote += "Feeding instructions: " + feedingInstruction + "\r\n";
                mineNote += "Plan: " + planName + "\r\n";
                mineNote += "Calories Per Day: " + calories + "\r\n";
            } else {
                feedingInstruction = productMealPackSelected[0].mealPacketsNeeded.topperinstruction;
                planName = "topper";
                mineNote += "Feeding instructions: " + feedingInstruction + "\r\n";
                mineNote += "Plan: " + planName + "\r\n";
                mineNote += "Calories Per Day: " + Math.ceil(calories / 2) + "\r\n";
            }

            var getNeutred = jQuery("#email_signup input[name=dog_castrat]").parents("li.accordion-item ").attr("sahil-value");
            getNeutred = jQuery("#email_signup input[name=dog_castrat][value='" + getNeutred + "']").data("val");

            var activity = jQuery("#email_signup input[name=dog_activity]").parents("li.accordion-item ").attr("sahil-value");
            activity = jQuery("#email_signup input[name=dog_activity][value='" + activity + "']").data("val");

            var Weight = jQuery("#email_signup input[name=dog_ideal_weight]").parents("li.accordion-item ").attr("sahil-value");
            Weight = jQuery("#email_signup input[name=dog_ideal_weight][value='" + Weight + "']").data("val");

            var gender = jQuery("#email_signup input[name=dog_gender]").parents("li.accordion-item ").attr("sahil-value");
            //Get rest of the notes
            mineNote += "age: " + $("#dog_age").attr("sahil-value") + "\r\n";
            mineNote += "breed: " + $("#dog_breed").attr("sahil-value") + "\r\n";
            mineNote += "gender: " + gender + "\r\n";
            mineNote += "neutered: " + getNeutred + "\r\n";
            mineNote += "weight: " + jQuery("#dog_weight").attr("sahil-value") + "\r\n";
            mineNote += "activity: " + activity + "\r\n";
            mineNote += "Weight: " + Weight;

            setTimeout(function () {
                // Add cart attributes for customer-level dog name tracking
                // This can be used by Shopify Flow to append to customer notes
                var cartData = {
                    note: mineNote,
                    attributes: {
                        "Dog Name": `${dogName} (${gender})`,
                        // 'Plan': planName,
                        // 'Feeding Instructions': feedingInstruction
                    },
                };

                jQuery.ajax({
                    url: "/cart/update.js",
                    type: "POST",
                    data: cartData,
                    success: function (result) {
                        try { mixpanel.track("Quiz Checkout", { Phase: "Go to Shopify Checkout" }); } catch (e) {}
                        window.location.href = "/checkout?discount=" + discount_code + "&MALVIKATEST10";
                    },
                    error: function (jqxhr, status, exception) {
                        console.log(exception);
                    },
                });
            }, 500);
        };
        moveAlong = function (value) {
            if (parray2.length) {
                if (value == "loop") {
                    var request = parray2.shift();
                }
                var data = parray2[0];
                console.log(data, "dataMine");
                if (data == undefined) {
                    cartNote();
                } else {
                    jQuery.ajax({
                        url: "/cart/add.js",
                        dataType: "json",
                        type: "post",
                        data: data,
                        success: function (itemData) {
                            setTimeout(function () {
                                moveAlong("loop");
                            }, 800);
                            // moveAlong('loop');
                        },
                        error: function (XMLHttpRequest) {
                            console.log(XMLHttpRequest);
                        },
                    });
                }
            } else {
                cartNote();
            }
        };

        // Form-encode parray2 the way stock Shopify themes do.
        // Cloudflare bot scoring treats JSON-body POSTs to /cart/add.js as more bot-like
        // than form-encoded ones, which was causing intermittent HTML challenge responses.
        var buildCartAddForm = function (items) {
            var form = new URLSearchParams();
            items.forEach(function (item, i) {
                if (item.id != null) form.append("items[" + i + "][id]", item.id);
                if (item.quantity != null) form.append("items[" + i + "][quantity]", item.quantity);
                if (item.selling_plan) form.append("items[" + i + "][selling_plan]", item.selling_plan);
                if (item.properties && typeof item.properties === "object") {
                    Object.keys(item.properties).forEach(function (key) {
                        var val = item.properties[key];
                        if (val != null) form.append("items[" + i + "][properties][" + key + "]", val);
                    });
                }
            });
            return form;
        };

        // Snapshots the current quiz state into a serializable payload that the
        // resume flow in templates/cart.liquid uses after the user solves a
        // Shopify/Cloudflare bot challenge in the new tab. Mirrors the DOM reads
        // cartNote() does, but returns the data instead of firing AJAX. Returns
        // null if the quiz isn't in a valid submittable state.
        var buildQuizCartPayload = function () {
            try {
                var dogName = $("#dog_name").attr("sahil-value");
                if (!dogName) return null;

                var quizCalories = calculate_quiz_calories();
                var plan = jQuery(".hQuizPlan.active").data("plan");
                var feedingInstruction, planName, caloriesPerDay;
                if (plan == "14") {
                    feedingInstruction = productMealPackSelected[0].mealPacketsNeeded.fullinstruction;
                    planName = "full";
                    caloriesPerDay = quizCalories;
                } else {
                    feedingInstruction = productMealPackSelected[0].mealPacketsNeeded.topperinstruction;
                    planName = "topper";
                    caloriesPerDay = Math.ceil(quizCalories / 2);
                }

                var getNeutred = jQuery("#email_signup input[name=dog_castrat]").parents("li.accordion-item ").attr("sahil-value");
                getNeutred = jQuery("#email_signup input[name=dog_castrat][value='" + getNeutred + "']").data("val");
                var activity = jQuery("#email_signup input[name=dog_activity]").parents("li.accordion-item ").attr("sahil-value");
                activity = jQuery("#email_signup input[name=dog_activity][value='" + activity + "']").data("val");
                var Weight = jQuery("#email_signup input[name=dog_ideal_weight]").parents("li.accordion-item ").attr("sahil-value");
                Weight = jQuery("#email_signup input[name=dog_ideal_weight][value='" + Weight + "']").data("val");
                var gender = jQuery("#email_signup input[name=dog_gender]").parents("li.accordion-item ").attr("sahil-value");

                var note =
                    "Dog name: " + dogName + "\r\n" +
                    "Feeding instructions: " + feedingInstruction + "\r\n" +
                    "Plan: " + planName + "\r\n" +
                    "Calories Per Day: " + caloriesPerDay + "\r\n" +
                    "age: " + $("#dog_age").attr("sahil-value") + "\r\n" +
                    "breed: " + $("#dog_breed").attr("sahil-value") + "\r\n" +
                    "gender: " + gender + "\r\n" +
                    "neutered: " + getNeutred + "\r\n" +
                    "weight: " + jQuery("#dog_weight").attr("sahil-value") + "\r\n" +
                    "activity: " + activity + "\r\n" +
                    "Weight: " + Weight;

                return {
                    items: parray2,
                    note: note,
                    attributes: { "Dog Name": dogName + " (" + gender + ")" },
                    redirectUrl: "/checkout?discount=" + discount_code + "&MALVIKATEST10",
                };
            } catch (e) {
                console.error("buildQuizCartPayload failed:", e);
                return null;
            }
        };

        mineAddFunction = function (attempt) {
            attempt = attempt || 1;
            var data = { items: parray2 };

            fetch("/cart/add.js", {
                body: buildCartAddForm(parray2),
                credentials: "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json",
                },
                method: "POST",
            })
                .then(async (response) => {
                    if (!response.ok) {
                        const text = await response.text();
                        console.error(
                            `cart/add.js failed (attempt ${attempt}): HTTP ${response.status} ${response.statusText}`,
                            "\nSent items:", JSON.stringify(data, null, 2),
                            "\nResponse body:", text.slice(0, 1000)
                        );

                        // Detect a bot challenge and hand off to the new-tab flow.
                        var trimmed = text.trim();
                        var looksLikeChallenge =
                            response.status === 403 ||
                            trimmed.indexOf("<") === 0 ||
                            trimmed.indexOf("Verifying your connection") !== -1;
                        if (looksLikeChallenge) {
                            var payload = buildQuizCartPayload();
                            if (payload) {
                                try {
                                    localStorage.setItem("pendingQuizCheckout", JSON.stringify({
                                        items: payload.items,
                                        note: payload.note,
                                        attributes: payload.attributes,
                                        redirectUrl: payload.redirectUrl,
                                        createdAt: Date.now(),
                                        attempts: 0,
                                    }));
                                } catch (e) { /* storage full or disabled */ }
                                // Navigate directly — no user confirmation needed.
                                // /cart?cfVerify=1 triggers the Cloudflare challenge as a
                                // full page, and templates/cart.liquid's resume script
                                // takes over after the user passes verification.
                                window.location.href = "/cart?cfVerify=1";
                                return;
                            }
                        }

                        throw new Error(`cart/add.js HTTP ${response.status}`);
                    }
                    return response.json();
                })
                .then((json) => {
                    if (!json) return;
                    console.log("Products added:", json);
                    cartNote();
                })
                .catch((err) => {
                    console.error("Error:", err);
                    if (attempt < 2) {
                        // Retry once for transient (non-challenge) failures.
                        setTimeout(function () { mineAddFunction(attempt + 1); }, 1500);
                    }
                });
        };
        // /cart/clear.js fires on quiz page load (see sections/page_quiz.liquid)
        // instead of here, so the clear and the add are minutes apart rather than
        // back-to-back. This drastically reduces the burst pattern that was
        // tripping Cloudflare's bot protection on /cart/add.js.
        console.log(parray2);
        mineAddFunction();
    });

    jQuery("#mealsPsRaw, #mealsPsRawSide").click(function (e) {
        e.preventDefault();
        jQuery(".mealsCat.gentlyCooked").attr("style", "display:none;opacity:0;");
        jQuery(".mealsCat.raw .MealsCatContentTags button").first().trigger("click");
        jQuery(".mealsCat.raw").attr("style", "display:block;opacity:1;");
        var elOffset = jQuery(".mealsCat.raw").offset().top;
        jQuery("html").animate({ scrollTop: elOffset }, 1000);
    });

    jQuery("#mealsPsGC, #mealsPsGCSide").click(function (e) {
        e.preventDefault();
        jQuery(".mealsCat.gentlyCooked .MealsCatContentTags button").first().trigger("click");
        //jQuery(".mealsCat").hide();
        jQuery(".mealsCat.raw").attr("style", "display:none;opacity:0;");
        jQuery(".mealsCat.gentlyCooked").attr("style", "display:block;");
        jQuery(".mealsCat.gentlyCooked").animate({ opacity: "1" }, 1000, function () {
            var elOffset = jQuery(".mealsCat.gentlyCooked").offset().top;
            jQuery("html").animate({ scrollTop: elOffset }, 1000);
        });
    });

    jQuery(".MealsCatContentTags button").click(function (e) {
        e.preventDefault();
        jQuery(this).parent().find("button").removeClass("active");
        jQuery(this).addClass("active");
        jQuery(".MealsCatContent").hide();
        id = jQuery(this).data("id");
        imge = jQuery(this).data("imge");
        jQuery(imge).attr("src", jQuery(this).data("imge-url"));
        jQuery("#" + id).show();
    });

    $(".slideMealsLinked").each(function () {
        var slider = "." + $(this).data("slider");
        var slider_dots = "#" + $(this).data("slider-dots");
        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: "<div class='slick-arrow slick-prev'><i class='fas fa-chevron-left'></i></div>",
            nextArrow: "<div class='slick-arrow slick-next '><i class='fas fa-chevron-right'></i></div>",
            fade: true,
            dots: true,
            centerPadding: "0px",
            dotsClass: "FWdots",
            appendDots: jQuery(slider_dots),
        });
    });

    $(".reviewSlider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<div class='slick-arrow slick-prev'><i class='fas fa-chevron-left'></i></div>",
        nextArrow: "<div class='slick-arrow slick-next '><i class='fas fa-chevron-right'></i></div>",
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "20px",
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".v3BlueSlider,.insta-slider, .google-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<div class='slick-arrow slick-prev'><i class='fas fa-chevron-left'></i></div>",
        nextArrow: "<div class='slick-arrow slick-next '><i class='fas fa-chevron-right'></i></div>",
        dots: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "20px",
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    var widt = $(document).width();
    if (widt < 800) {
        $(".pickyeater, .health, .weight, .digestion").slick({
            lazyLoad: "ondemand",
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            prevArrow: "<div class='slick-arrow slick-prev'><i class='fas fa-chevron-left'></i></div>",
            nextArrow: "<div class='slick-arrow slick-next '><i class='fas fa-chevron-right'></i></div>",
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    $(".compReviewsSlider").slick({
        lazyLoad: "ondemand",
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: "<div class='slick-arrow slick-prev'><i class='fas fa-chevron-left'></i></div>",
        nextArrow: "<div class='slick-arrow slick-next '><i class='fas fa-chevron-right'></i></div>",
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(window).on("load resize orientationchange", function () {
        $("#HpBenefitsSlick_comment for new design, #joinThePack").each(function () {
            var $carousel = $(this);
            if ($(window).width() > 768) {
                if ($carousel.hasClass("slick-initialized")) {
                    $carousel.slick("unslick");
                }
            } else {
                if (!$carousel.hasClass("slick-initialized")) {
                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        centerMode: true,
                        centerPadding: "70px",
                        arrows: false,
                        dots: false,
                    });
                }
            }
        });
    });

    $(".quizMealSelect").click(function () {
        $(this).closest(".quizMeal").toggleClass("active");
        jQuery("#goToStep12").removeClass("disabled");
    });

    /* Qty selector product */
    $(".add-product").click(function () {
        $("#Quantity").val(+$("#Quantity").val() + 1);
    });

    $(".sub-product").click(function () {
        if ($(this).next().val() > 1) {
            if ($(this).next().val() > 1)
                $(this)
                    .next()
                    .val(+$(this).next().val() - 1);
        }
    });

    $(".pBimg").wrap('<span style="display:block"></span>').css("display", "block").parent().zoom();

    $("#product-images-thumbs").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        infinite: false,
        verticalSwiping: true,
        asNavFor: "#product-images",
        dots: false,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-up'><i class='fa fa-angle-up' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-down'><i class='fa fa-angle-down' aria-hidden='true'></i></button>",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                    verticalSwiping: false,
                },
            },
        ],
    });

    $("#product-images-thumbs").on("afterChange", function (event, slick, currentSlide, nextSlide) {
        $("#product-images-thumbs.slick-slide").removeClass("slick-current");
        $("#product-images-thumbs .slick-slide:not(.slick-cloned)").eq(currentSlide).addClass("slick-current");
    });

    const initSliderProduct = () => {
        $("#product-images").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            asNavFor: "#product-images-thumbs",
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: true,
                        prevArrow: "<button type='button' class='slick-arrow slick-prev'>&#8249;</button>",
                        nextArrow: "<button type='button' class='slick-arrow slick-next'>&#8250;</button>",
                    },
                },
            ],
        });
    };

    initSliderProduct();

    $("#product-images-thumbs .slick-slide:not(.slick-cloned)").eq(0).addClass("slick-current");

    if ($(document).width() > 768) {
        $("#product-images")
            .slickLightbox()
            .on({
                "show.slickLightbox": function () {
                    $("body").css({ overflow: "hidden" });
                },
                "hide.slickLightbox": function () {
                    $("body").css({ overflow: "visible" });
                },
            });
    }

    // Tabs product

    $(".tabs-product .title").on("click", function () {
        let activeTab = $(this).data("href");
        $(".tabs-product .title").removeClass("active");
        $(this).addClass("active");
        $(".tabs-product .tab").removeClass("active");
        $(activeTab).addClass("active");
    });

    const get_current_variant = (product, coption) => {
        var variants = product.variants;
        var found = false;
        variants.forEach(function (variant) {
            if (variant.option1 == coption) {
                found = variant;
                console.log(found);
            }
        });
        return found || null;
    };

    $(".productVariationOption").click(function () {
        $(".hProdOptions .productVariationOption").each(function () {
            $(this).removeClass("active");
        });
        $(this).addClass("active");
        var current_product = JSON.parse($("[data-product-json]").html());
        current_option = get_current_variant(current_product, $(this).data("value"));
        $("#productSelect [value=" + current_option.id + "]").attr("selected", "true");
        pp = (current_option.price / 100).toFixed(2);
        if (current_option.compare_at_price != null) {
            cp = (current_option.compare_at_price / 100).toFixed(2);
            savep = (100 - (current_option.price / current_option.compare_at_price) * 100).toFixed(0);
            new_price = "<span class='old-price mpPrice' data-price='" + current_option.compare_at_price + "'>";
            new_price += "List Price<span class='old-priceVal' data-compare-price>$" + cp + "</span></span>";
            new_price +=
                "<span class='productPriceSaleTxt'>Sale Price</span><span class='productCVprice' data-price='" +
                current_option.price.toFixed(2) +
                "' data-product-price>$";
            new_price += pp + "</span><span class='productCVSave'>save " + savep + "%</span>";
            new_price +=
                "<span class='visually-hidden mpPrice ' data-price='" +
                current_option.compare_at_price +
                "' data-compare-text style='display:none'>";
            new_price += "$165.00</span>";
        } else {
            new_price +=
                "<span class='productPriceSaleTxt'>Sale Price</span><span class='productCVprice' data-price='" +
                current_option.price +
                "' data-product-price>$";
            new_price += pp + "</span><span class='productCVSave'>save 35%</span>";
            new_price +=
                "<span class='visually-hidden mpPrice ' data-price='" +
                current_product.current_option +
                "' data-compare-text style='display:none'>";
            new_price += "$" + current_option.compare_at_price.toFixed(2) + "</span>";
        }
        $(".price-wrapper").html(new_price);
    });

    const defaultTo = (value, defaultValue) => {
        return value == null || value !== value ? defaultValue : value;
    };

    const formatMoney = (cents) => {
        var moneyFormat = "${{amount}}";
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        //var formatString = (format || moneyFormat);
        var formatString = moneyFormat;
        const formatWithDelimiters = (number, precision, thousands, decimal) => {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        };

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_space_separator":
                value = formatWithDelimiters(cents, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ",", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
    $("#PCartProds, #CartPProds").on("click", ".PcartRemove", function () {
        $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            dataType: "json",
            success: function () {
                location.reload();
            },
            error: function () {
                console.log("Error removing items from cart");
            },
        });
    });
});

$(document).on("change", ".hQuizCookedRecipes input", function () {
    var thisM = this;
    setTimeout(function () {
        console.log($(thisM).prop("checked"));
        if ($(thisM).prop("checked")) {
            $(thisM).parents(".hQuizRecipe").addClass("active");
        } else {
            $(thisM).parents(".hQuizRecipe").removeClass("active");
        }
    }, 250);
});

$(document).click(function (event) {
    if (!$(event.target).closest(".MainCart-Wr").length) {
        $("#PopupQuiz").fadeOut();
    }
});
